<nav class="public-header navbar navbar-expand-lg navbar-light fixed-top">
  <a class="navbar-brand" routerLink="../../login">
    <img src="../../../../assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}" height="30">
  </a>

  <ul class="navbar-nav ml-auto">
    <button mat-button [matMenuTriggerFor]="langMenu">
      {{ lang.toUpperCase() }}
      <mat-icon fontSet="fas" fontIcon="fa-flag"></mat-icon>
    </button>
    <mat-menu #langMenu="matMenu">
      <a mat-menu-item (click)="onSelectLang('en')" *ngIf="lang === 'it'">English</a>
      <a mat-menu-item (click)="onSelectLang('it')" *ngIf="lang === 'en'">Italiano</a>
    </mat-menu>
    <!--
    <li class="nav-item dropdown" ngbDropdown>
      <div class="dropdown-wrapper">
        <button class="nav-link dropdown-toggle btn btn-light px-2" id="navbarDropdown" ngbDropdownToggle>
          {{ lang.toUpperCase() }}
        </button>
        <div class="public-lang-menu dropdown-menu dropdown-menu-right" ngbDropdownMenu
          aria-labelledby="navbarDropdown">
          <a class="dropdown-item" mat-menu-item routerLink="/en" *ngIf="lang === 'it'">English</a>
          <a class="dropdown-item" mat-menu-item routerLink="/it" *ngIf="lang === 'en'">Italiano</a>
        </div>
      </div>
    </li> -->
  </ul>
</nav> <!-- /.navbar -->
